import { useEvent } from '@emerald-works/react-event-bus-client'
import React from 'react'
import { useSelector } from 'react-redux'
import { buildToolkitUrl } from '../helpers/toolkit'
import { AppSlice } from '../reducers'
import { CONSTANTS } from '../util/constants'

const useExternalApp = ({ tenantKey = CONSTANTS.DEFAULT_CLUB_TENANT_KEY, excludeProtocol = false } = {}) => {
  const envInfo = useSelector(AppSlice.selectors.selectEnvInfo)
  const [getEnvInfo] = useEvent([AppSlice.eventBus.getEnvInfo])

  const baseToolkitUrl = React.useMemo(() => {
    if (process.env.REACT_APP_TOOLKIT_URL) {
      return process.env.REACT_APP_TOOLKIT_URL
    }

    if (!envInfo) {
      getEnvInfo.trigger()
      return null
    }

    const { stage, tld } = envInfo
    return buildToolkitUrl(tenantKey, stage, tld, excludeProtocol)
  }, [envInfo, tenantKey, getEnvInfo, excludeProtocol])

  return { baseToolkitUrl }
}

export default useExternalApp
